// src/utils/api.js
import axios from 'axios';
import { API_BASE_URL } from '../config/apiConfig';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 0, // NO TIMEOUT - wait indefinitely
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Retry logic for failed requests (useful for slow connections)
const retryRequest = async (requestFn, retries = 2, delay = 1000) => {
  for (let i = 0; i <= retries; i++) {
    try {
      return await requestFn();
    } catch (error) {
      if (i === retries) throw error;
      // Exponential backoff: wait longer between retries
      await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, i)));
    }
  }
};

// Helper function to make API calls with retry
export const apiWithRetry = {
  get: async (url, config = {}) => {
    return retryRequest(() => api.get(url, { ...config, timeout: 0 }), 2, 1000);
  },
  post: async (url, data, config = {}) => {
    return retryRequest(() => api.post(url, data, { ...config, timeout: 0 }), 2, 1000);
  },
  put: async (url, data, config = {}) => {
    return retryRequest(() => api.put(url, data, { ...config, timeout: 0 }), 2, 1000);
  },
  delete: async (url, config = {}) => {
    return retryRequest(() => api.delete(url, { ...config, timeout: 0 }), 2, 1000);
  },
};

export default api;
